import { type SessionApproverChoiceConstructor } from '@webapp/modules/accounts-payable/entities/SessionApproverChoice'
import { type SessionApproverChoiceApiModel } from '../api-models/SessionApproverChoiceApiModel'

export const mapSessionApproverChoiceApiModel = (
  model: SessionApproverChoiceApiModel
): SessionApproverChoiceConstructor => ({
  id: model.id,
  user: {
    id: model.user.id,
    firstName: model.user.first_name,
    lastName: model.user.last_name,
  },
})
